module.exports = __webpack_public_path__ + "static/media/series-accent.5b78ba4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/series-accent.svg
// module id = 119
// module chunks = 0